export default __webpack_public_path__ + "static/media/onboarding_cert_of_liability_insurance.2be6c524.webp";